import { useEffect, useState } from "react";

const useSelection = () => {
  const [elements, setElements] = useState<Element[]>([]);
  const [text, setText] = useState("");

  useEffect(() => {
    const handleSelectionChange = () => {
      const selection = document.getSelection();
      if (!selection?.rangeCount) {
        return;
      }

      const range = selection.getRangeAt(0);
      setText(selection.toString());

      const children = Array.from(range.cloneContents().querySelectorAll("*"));
      if (
        selection.anchorNode?.nodeName === "IMG" &&
        isElement(range.commonAncestorContainer)
      ) {
        setElements([range.commonAncestorContainer]);
      } else if (
        children.length === 1 &&
        children.some((elm) => elm.nodeName === "BR") &&
        isElement(range.commonAncestorContainer)
      ) {
        setElements([range.commonAncestorContainer]);
        return;
      } else if (children.length > 0) {
        setElements(children);
      } else {
        const parentElement = range.commonAncestorContainer.parentElement;
        if (!parentElement) {
          setElements([]);
          return;
        }
        setElements([parentElement]);
      }
    };
    document.addEventListener("selectionchange", handleSelectionChange);
    return () => {
      document.removeEventListener("selectionchange", handleSelectionChange);
    };
  }, []);
  return { elements, text };
};

function isElement(node: Node): node is Element {
  return node.nodeType === Node.ELEMENT_NODE;
}

export default useSelection;
